import productsData from './products.json';

export function slugify(value) {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function getProducts() {
  return productsData;
}

export function getProduct(slug) {
  return getProducts().find((product) => product.slug === slug);
}

export function getRecommendedProducts(current, products, limit = 6) {
  return products
    .filter((product) => product.slug !== current.slug)
    .map((product) => {
      const sharedConditions = product.conditions.filter((condition) =>
        current.conditions.includes(condition)
      ).length;
      const categoryScore = product.category === current.category ? 3 : 0;
      return { product, score: categoryScore + sharedConditions };
    })
    .sort((a, b) => b.score - a.score || a.product.name.localeCompare(b.product.name))
    .slice(0, limit)
    .map(({ product }) => product);
}
